const DEFAULT_SORT_OPTIONS = [
    { value: 'joined', label: 'Recently Joined' },
    { value: 'joined_asc', label: 'Oldest Joined' },
    { value: 'last_active', label: 'Recently Active' },
    { value: 'last_active_asc', label: 'Least Recently Active' },
    { value: 'name', label: 'Name (A-Z)' },
    { value: 'name_desc', label: 'Name (Z-A)' }
];

function DesktopListControls({
    sortBy,
    onSortChange,
    sortOptions = [],
    displayCount,
    totalMembers,
    showMap = true,
    mapOnly = false,
    onToggleMapOnly
}) {
    const options = sortOptions.length > 0 ? sortOptions : DEFAULT_SORT_OPTIONS;

    const renderResultCount = () => {
        if (displayCount === undefined || totalMembers === undefined) {
            return null;
        }

        return (
            <div className="result-count">
                {`Displaying ${displayCount} of ${totalMembers} users found`}
            </div>
        );
    };

    return (
        <div className="list-controls">
            <div className="sort-controls">
                <label htmlFor="sort-select">Sort by:</label>
                <select
                    id="sort-select"
                    value={sortBy}
                    onChange={(e) => onSortChange(e.target.value)}
                    className="sort-select"
                >
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>

            {renderResultCount()}

            {showMap && (
                <div className="view-controls">
                    <button
                        type="button"
                        onClick={() => onToggleMapOnly(false)}
                        className={`view-btn ${!mapOnly ? 'active' : ''}`}
                        aria-label="Card view with map"
                    >
                        Cards
                    </button>
                    <button
                        type="button"
                        onClick={() => onToggleMapOnly(true)}
                        className={`view-btn ${mapOnly ? 'active' : ''}`}
                        aria-label="Map only view"
                    >
                        Map Only
                    </button>
                </div>
            )}
        </div>
    );
}

export default DesktopListControls;
